import React, { useEffect, useState, useCallback, useRef } from 'react';
import Table from '../components/Table/indexAgent';
import LeadService from '../core/services/leadsService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Avatar from '@mui/material/Avatar';
import { Card, Box } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { Autocomplete } from '@mui/material';
import { debounce, throttle } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import Pagination from '@mui/material/Pagination';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { useDateTime } from '../pages/ContextDateandTime/DateTimeContext';
import { styled, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, Grid, CardContent } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { GoogleMap, Marker, MarkerF, useJsApiLoader, InfoWindow, OverlayView } from '@react-google-maps/api';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import PeopleIcon from '@mui/icons-material/People';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
const useStyles = makeStyles((theme) => ({
    LeadTable: {
        overflowX: 'auto',
        width: '1310px',
        [theme.breakpoints.down('md')]: {
            overflowX: 'auto',
            width: '1080px',
        },
        [theme.breakpoints.up('lg')]: {
            overflowX: 'auto',
            width: '1625px',
        },
        [theme.breakpoints.between('macScreen', 'mlg')]: {
            width: '1390px',
            overflowX: 'auto',
        },
        [theme.breakpoints.up('xl')]: {
            overflowX: 'auto',
            width: 'auto',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
        },
    },
    GetAllAgentsTableStyle: {
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
        },
    },
    textFieldStyleRes: {
        width: '260px',
        [theme.breakpoints.down('md')]: {
            width: '240px',
        }
    },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};
const containerStyle = {
    width: '100%',
    height: 'calc(90vh - 65px)',
    position: 'relative',
    borderRadius: '20px',
};

const Agents = () => {
    const classes = useStyles();
    const theme = useTheme();
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA',
    });
    const getInitialButtonVisibility = () => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            return timeElapsed >= 480000;
        }
        return true;
    };
    const [logOutModal, setLogOutModal] = React.useState(false);
    const userData = JSON.parse(localStorage.getItem('user'));
    const LoginUserID = userData?.user?.organization_id;
    const [GetAllAgents, setGetAllAgents] = React.useState([]);
    const [getAllAgentsForMap, setGetAllAgentsForMap] = useState([]);
    const [CountUser, setCountUser] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [showTooltip, setShowTooltip] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [emailShowTooltip, setEmailShowTooltip] = React.useState(false);
    const { selectedIds, setSelectedIds, setRowSelection } = useDateTime();
    const [ConfirmationOpen, setConfirmationOpen] = React.useState(false);
    const [isLoadingEmail, setIsLoadingEmail] = useState(false);
    const [buttonVisible, setButtonVisible] = useState(getInitialButtonVisibility);
    const [SyncVisible, setSyncVisible] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [getPefferedLocation, setGetPefferedLocation] = useState();
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [viewMode, setViewMode] = useState(localStorage.getItem('viewMode') || 'list');
    const [mapCenter, setMapCenter] = React.useState({ lat: 34.052235, lng: -118.243683 });
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = useState('');
    const [formattedFromDate, setFormattedFromDate] = useState('');
    const [formattedToDate, setFormattedToDate] = useState('');
    const [CountAgents, setCountAgents] = useState('');
    const [zoom, setZoom] = React.useState(8);
    const mapRef = useRef(null);
    const navigate = useNavigate();
    const abortControllerRef = useRef(null);


    const options = [
        { label: 'New User', value: '' },
        { label: 'Last Login', value: 'last_login' },
    ];
    const filterOptions = [
        { label: 'All', value: '' },
        { label: 'Active', value: 'active' },
        { label: 'In Active ', value: 'inactive' },
        { label: 'Paused', value: 'paused' },
        { label: 'Deleted', value: 'deleted' },
        // { label: 'Imported Agent', value: 'imported' },
    ];
    const AllLocation = async () => {
        try {
            const res = await LeadService.getLocationForAgent();
            if (res.data.success) {
                setGetPefferedLocation(res.data.data);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const CountAgentsOrgAdmin = async () => {
        try {
            const resp = await LeadService.CountAgentAndCustomerOrgAdmin();
            if (resp?.data?.success) {
                setCountAgents(resp?.data);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    const iconMap = {
        'Total Agents Count': <PeopleIcon style={{ color: '#3674c4', fontSize: '35px' }} />,
        'Total No of System Generated Agents': <EmojiPeopleIcon style={{ color: '#3674c4', fontSize: '35px' }} />,
        'Total No of Active ( logged in) Agents': <LoginIcon style={{ color: '#3674c4', fontSize: '35px' }} />,
    };
    useEffect(() => {
        AllLocation();
        CountAgentsOrgAdmin();
    }, []);

    const getAgents = async (
        page,
        searchTerm = '',
        selectedValue = '',
        selectedFilterValue = '',
        selectedLocation = '',
        viewMode,
        signal,
        fromDate = '', // Add fromDate parameter
        toDate = '' // Add toDate parameter
    ) => {
        try {
            if (viewMode === 'list') {
                setIsLoading(true);
                const isPaginated = 1;
                const selectedOrganization = '';
                const res = await LeadService.getAgentsApi(
                    page,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization,
                    '',
                    isPaginated,
                    { signal },
                    fromDate, // Pass fromDate here
                    toDate // Pass toDate here
                );
                if (res?.data?.success) {
                    setGetAllAgents(res?.data?.agents?.data);
                    setCurrentPage(res?.data?.agents?.current_page);
                    setTotalPages(Math.ceil(res?.data?.agents?.total / res?.data?.agents?.per_page));
                    return;
                } else {
                    setGetAllAgents([]);
                    setTotalPages(0);
                }
            } else {
                const selectedOrganization = '';
                const res = await LeadService.getAgentsApi(
                    page,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization
                );
                if (res?.data?.success) {
                    const agentsData = res?.data?.agents;
                    setGetAllAgentsForMap(agentsData);
                    // Store the map data in sessionStorage
                    sessionStorage.setItem('agentsMapData', JSON.stringify(agentsData));
                    return;
                } else {
                    setGetAllAgentsForMap([]);
                    setTotalPages(0);
                }
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetAgents = useCallback(
        throttle((page, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, signal, formattedFromDate, formattedToDate) => {
            getAgents(page, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, signal, formattedFromDate, formattedToDate);
        }, 2000),
        []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchAgents = useCallback(
        debounce((page, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, formattedFromDate, formattedToDate) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetAgents(
                page,
                searchTerm,
                selectedValue,
                selectedFilterValue,
                selectedLocation,
                viewMode,
                abortController.signal,
                formattedFromDate,
                formattedToDate
            );
        }, 500),
        [throttledGetAgents]
    );
    useEffect(() => {
        if (viewMode === 'list') {
            fetchAgents(currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, formattedFromDate, formattedToDate);
        }
    }, [currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, formattedFromDate, formattedToDate]);
    const HandleChangeLocation = async (event, newValue) => {

        setSelectedLocation(newValue ? newValue.id : '')
        setCurrentPage(1);
    };

    const HandleChangeLastLogin = async (event, newValue) => {
        setSelectedValue(newValue ? newValue.value : '');
        setCurrentPage(1);
    };
    const HandleChangeFilter = async (event, newValue) => {
        setSelectedFilterValue(newValue ? newValue.value : '');
        setCurrentPage(1);
    };

    const handlePageChange = async (event, value) => {
        setCurrentPage(value);
        await fetchAgents(currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation);
    };

    useEffect(() => {
        let intervalId;
        if (viewMode === 'map') {
            const cachedData = sessionStorage.getItem('agentsMapData');
            if (cachedData) {
                setGetAllAgentsForMap(JSON.parse(cachedData));
            }
        }
        fetchAgents(currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode);
        if (viewMode === 'map') {
            // Set an interval to call the API every 30 seconds after the first call
            intervalId = setInterval(() => {
                fetchAgents(currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode);
            }, 30000);
        }

        return () => {
            // Clear the interval when the component unmounts or viewMode changes
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, viewMode, fetchAgents]);

    const handleSearchChange = (event) => {
        const newSearchValue = event.target.value;
        setSearchTerm(newSearchValue);
        if (newSearchValue !== null) {
            localStorage.setItem('searchTerm', JSON.stringify(newSearchValue));
        } else {
            localStorage.removeItem('searchTerm');
        }
        setCurrentPage(1);
    };

    const handleClear = () => {
        localStorage.removeItem('searchTerm');
        setSearchTerm('');
        setCurrentPage(1);
        fetchAgents(1, '');
    };

    const getCountData = async () => {
        try {
            const res = await LeadService.TotalAllCountData();
            if (res?.data?.success) {
                setCountUser(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getCountData();
    }, []);

    const handleDeleteOpen = (id) => {
        setOpen(true);
        setDeleteId(id);
    };

    const handleClose = () => {
        setOpen(false);
        setDeleteId(null);
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const handleViewClick = (row) => {
        if (row?.original?.deleted_at) {
            toast.error('This agent user is deleted');
        } else {
            navigate(`/agents-details/${row?.original?.id}`);
        }
    };

    const column = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
        },
        // {
        //     accessorKey: 'name',
        //     header: 'User Name',
        //     Cell: ({ row }) => (
        //         <div style={{ display: 'flex', alignItems: 'center' }}>
        //             <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
        //             <span style={{ marginLeft: 10 }}>{row?.original?.name}{' '}{row?.original?.last_name}</span>
        //         </div>
        //     ),
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     size: 200,
        //     muiTableHeadCellProps: {
        //         align: 'center',
        //     },
        // },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableBodyCellProps: ({ row }) => ({
                onClick: () => handleViewClick(row), // Attach the handleViewClick function
                style: {
                    cursor: 'pointer', // Make it clear that it's clickable
                    color: row?.original?.deleted_at ? '#dc1919' : 'inherit', // Highlight deleted users
                    fontWeight: 'bold',
                },
            }),
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            // enableClickToCopy: true,
            enableSorting: false,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            accessorKey: 'location',
            header: 'Location',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },

        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,


            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return 'Never Logged In';
            },
        },
        {
            accessorKey: 'app_version',
            header: 'App Version',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                if (typeof value === 'string') {
                    const trimmedValue = value.trim();
                    // Target specific values
                    const specialCases = ['premier', 'founder', 'elite'];
                    if (specialCases.includes(trimmedValue.toLowerCase())) {
                        return trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1);
                    }
                    return trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1); // General fallback
                }
                return value || ''; // Default for non-string or empty values
            },
        },
        {
            id: 'actions',
            accessorKey: 'SeeMore',
            header: 'See More',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 50,
            enableSorting: false,
            Cell: ({ row }) => {
                const handleViewClick = () => {
                    if (row?.original?.deleted_at) {
                        return toast.error('This agent user is deleted');
                    } else {
                        localStorage.setItem('viewMode', 'list');
                        navigate(`/agents-details/${row?.original?.id}`);
                    }
                };

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IconButton aria-label="view" onClick={handleViewClick}>
                            <VisibilityIcon />
                        </IconButton>
                        {/* <IconButton
                        aria-label="edit">
                        <EditIcon sx={{ color: '#2883CC' }} />
                    </IconButton> */}
                        {/* <IconButton
                        onClick={() => handleDeleteOpen(row?.original?.id)}
                        aria-label="delete">
                        <DeleteIcon sx={{ color: '#E71D36' }} />
                    </IconButton> */}
                    </div>
                );
            },
        },
    ];

    const OpenModalCronJob = async () => {
        setConfirmationOpen(true);
    };

    const handleCloseModel = () => {
        setConfirmationOpen(false);
    };

    const HandleRunCronJob = async () => {
        try {
            setIsLoadingEmail(true);
            setSyncVisible(false);
            const res = await LeadService.runCronJob();
            setIsLoadingEmail(false);
            if (res?.data?.success) {
                toast.success('Sync Users Successfully!');
                setConfirmationOpen(false);
                setSyncVisible(true);
                return;
            }
        } catch (error) {
            toast.error(error.message);
            console.error(error);
        }
    };
    useEffect(() => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            if (timeElapsed < 480000) {
                // If less than 2 minutes have passed
                setButtonVisible(false);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000 - timeElapsed);
            }
        }
    }, []);

    const handleEmailSend = async () => {
        if (selectedIds.length == 0) {
            return toast.error('Please select any users to send email');
        }
        try {
            setIsLoadingEmail(true);
            setButtonVisible(false);
            const res = await LeadService.EmailToAgents(selectedIds);
            setIsLoadingEmail(false);
            if (res?.data?.success) {
                toast.success(res.data.message);

                await setSelectedIds('');
                setRowSelection({});
                const timestamp = Date.now();
                localStorage.setItem('emailSentTimestamp', timestamp);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000);
                return;
            }
        } catch (error) {
            toast.error(error.message);
            console.error(error);
        }
    };

    useEffect(() => {
        // Retrieve view mode from localStorage when component mounts
        const savedViewMode = localStorage.getItem('viewMode');
        if (savedViewMode) {
            setViewMode(savedViewMode);
        }
    }, []);
    const [selectedAgent, setSelectedAgent] = useState(null);

    const handleMarkerClick = (agent) => {
        if (agent) {
            setSelectedAgent(agent);
        }
    };

    const handleProfileClick = () => {
        if (selectedAgent?.deleted_at) {
            return toast.error('This agent user is deleted');
        } else if (selectedAgent) {
            localStorage.setItem('viewMode', 'map');
            navigate(`/agents-details/${selectedAgent.id}`);
        }
    };

    const handleCloseCard = () => {
        setSelectedAgent(null); // Close the card
    };
    const adjustTimeBasedOnOffsetForSendData = (date, offsetInHours) => {
        const dateObj = new Date(date);
        const utcDate = new Date(dateObj.toUTCString()); // Convert to UTC
        if (offsetInHours > 0) {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        } else {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        }
        return utcDate;
    };

    const formatDate = (date) => {
        return date ? dayjs(date).format('DD-MM-YYYY HH:mm:ss') : null;
    };

    const handleSearchClick = async (fromDate, toDate) => {
        const currentDate = new Date();
        const formattedCurrentDate = formatDate(currentDate);

        if (!fromDate) {
            return toast.error('Please select the from date.');
        }

        if (!toDate) {
            return toast.error('Please select the to date.');
        }

        if (toDate < fromDate) {
            return toast.error('Please select a to date later than the start date.');
        }
        if (fromDate !== null) {
            localStorage.setItem('fromDate', JSON.stringify(fromDate));
        }
        if (toDate !== null) {
            localStorage.setItem('toDate', JSON.stringify(toDate));
        }
        const userOffset = getUserOffset();
        const formattedFrom = formatDate(adjustTimeBasedOnOffsetForSendData(fromDate, userOffset));
        const formattedTo = formatDate(adjustTimeBasedOnOffsetForSendData(toDate, userOffset));

        // Set formatted dates in state
        setFormattedFromDate(formattedFrom);
        setFormattedToDate(formattedTo);
        localStorage.setItem('formattedFromDate', JSON.stringify(formattedFrom));
        localStorage.setItem('formattedToDate', JSON.stringify(formattedTo));

        fetchAgents(1, searchTerm, selectedValue, selectedFilterValue, selectedLocation, 'list', formattedFromDate, formattedToDate);
    };

    useEffect(() => {
        const savedFromDate = localStorage.getItem('fromDate');
        const savedToDate = localStorage.getItem('toDate');
        if (savedFromDate) {
            const parsedFromDate = dayjs(JSON.parse(savedFromDate));
            setFromDate(parsedFromDate);
            const userOffset = getUserOffset();
            const formattedFrom = formatDate(adjustTimeBasedOnOffsetForSendData(parsedFromDate, userOffset));
            setFormattedFromDate(formattedFrom);
        }
        if (savedToDate) {
            const parsedToDate = dayjs(JSON.parse(savedToDate));
            setToDate(parsedToDate);
            const userOffset = getUserOffset();
            const formattedTo = formatDate(adjustTimeBasedOnOffsetForSendData(parsedToDate, userOffset));
            setFormattedToDate(formattedTo);
        }
        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm) {
            setSearchTerm(JSON.parse(savedSearchTerm));
        }
    }, []);

    const clearALLState = () => {
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('formattedFromDate');
        localStorage.removeItem('formattedToDate');
        localStorage.removeItem('searchTerm');

        setFromDate('');
        setToDate('');
        setSelectedValue('');
        setSelectedFilterValue('');
        setSelectedLocation('');
        setFormattedFromDate('');
        setSearchTerm('');
        setFormattedToDate('');
        fetchAgents(1, '', '', '', '', 'list');
    };

    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingEmail || (isLoading && <LinearProgress />)}</div>
            <ScrollAnimation animateIn="fadeIn">
                <div>
                    {viewMode !== 'map' && (
                        <>
                            <Grid container spacing={2}>
                                {[
                                    { label: 'Total Agents Count', value: CountAgents?.totalAgents },
                                    { label: 'Total No of System Generated Agents', value: CountAgents?.totalSystemAgents },
                                    { label: 'Total No of Active ( logged in) Agents', value: CountAgents?.totalActiveAgents },
                                ]?.map((item, index) => (
                                    <Grid item xs={12} sm={4} md={4} lg={4} key={index}>
                                        <Card
                                            sx={{
                                                borderRadius: '20px',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                background: 'linear-gradient(#26c7f3, #316ec1)',
                                                marginBottom: '20px',
                                            }}
                                        >
                                            <CardContent>
                                                <Box style={{ padding: '15px' }}>
                                                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: '#fff',
                                                                width: { xs: '30px', sm: '50px', md: '50px', lg: '60px' },
                                                                height: { xs: '30px', sm: '50px', md: '50px', lg: '60px' },
                                                            }}
                                                        >
                                                            {iconMap[item?.label]}
                                                        </Avatar>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '1.25rem', sm: '1.4375rem', md: '1.4375rem' }, // Responsive font sizes
                                                                fontWeight: 'bold',
                                                                color: '#fff',
                                                                fontFamily: 'inherit',
                                                            }}
                                                        >
                                                            {item?.value}
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ marginTop: '20px' }}>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '10px', sm: '12px', md: '14px' },
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                fontFamily: 'inherit',
                                                            }}
                                                        >
                                                            {item?.label}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>

                            <Box style={{ display: 'Grid', justifyContent: 'center', gap: '20px' }}>
                                <Card
                                    sx={{
                                        padding: '20px',
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        background: 'white',
                                        width: 'auto',
                                        transform: 'scale(1)',
                                        transition: 'transform 0.3s ease-in-out',
                                    }}
                                >
                                    <Box style={{ display: 'grid', gap: '20px' }}>
                                        <Box style={{ display: 'flex', gap: '20px' }}>
                                            <Autocomplete
                                                options={options}
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => <TextField {...params} label="Last Login" />}
                                                value={options.find((option) => option.value === selectedValue) || null}
                                                onChange={HandleChangeLastLogin}
                                                disabled={isLoading}
                                                className={classes.textFieldStyleRes}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                            />

                                            <Autocomplete
                                                options={filterOptions}
                                                getOptionLabel={(filterOptions) => filterOptions.label}
                                                renderInput={(params) => <TextField {...params} label="Filters" />}
                                                value={filterOptions.find((filterOptions) => filterOptions.value === selectedFilterValue) || null}
                                                onChange={HandleChangeFilter}
                                                disabled={isLoading}
                                                className={classes.textFieldStyleRes}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                            />
                                            <Autocomplete
                                                options={getPefferedLocation}
                                                getOptionLabel={(getPefferedLocation) => getPefferedLocation.region_name}
                                                renderInput={(params) => <TextField {...params} label="Preferred Location" />}
                                                value={getPefferedLocation?.find((location) => location.id === selectedLocation) || null}
                                                onChange={HandleChangeLocation}
                                                disabled={isLoading}
                                                className={classes.textFieldStyleRes}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                            />

                                            <TextField
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                                placeholder="Search by name , email"
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={handleClear} aria-label="clear search">
                                                                <ClearIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                variant="outlined"
                                                className={classes.textFieldStyleRes}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                            />
                                        </Box>

                                        <Box style={{ display: 'flex', gap: '20px' }}>
                                            <Box>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DateTimePicker
                                                        sx={{
                                                            overflow: 'hidden',
                                                            '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },
                                                            '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#c1c1c1',
                                                            },
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '12px',
                                                            },
                                                        }}
                                                        value={fromDate}
                                                        onChange={(newDate) => setFromDate(newDate)}
                                                        className={classes.textFieldStyleRes}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                            <Box>
                                                <div>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DateTimePicker
                                                            sx={{
                                                                // marginBottom: '200x',
                                                                overflow: 'hidden',
                                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#c1c1c1',
                                                                },
                                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: '#c1c1c1',
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    borderRadius: '12px',
                                                                },
                                                            }}
                                                            value={toDate}
                                                            onChange={(newDate) => setToDate(newDate)}
                                                            className={classes.textFieldStyleRes}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </Box>
                                            <Box style={{ display: 'flex', gap: '5px' }}>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        cursor: 'pointer',
                                                        borderRadius: '12px',
                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                        fontWeight: 'bold',
                                                        height: '40px',
                                                        marginTop: '6px',
                                                        background: '#5379BD',
                                                        fontFamily: 'inherit',
                                                    }}
                                                    onClick={() => handleSearchClick(fromDate, toDate)}
                                                >
                                                    {' '}
                                                    Search By Date
                                                </Button>
                                                <Button
                                                    style={{
                                                        width: '30px',
                                                        height: '39px',
                                                        border: '1px solid gray',
                                                        background: '#bababa',
                                                        borderRadius: '12px',
                                                        fontWeight: 'bold',
                                                        marginLeft: '0px',
                                                        cursor: 'pointer',
                                                        marginTop: '6px',
                                                        color: 'black',
                                                    }}
                                                    sx={{ fontFamily: 'inherit' }}
                                                    onClick={clearALLState}
                                                >
                                                    Clear
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Card>
                            </Box>
                        </>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                        <div>
                            <Typography style={{ fontSize: '36px', fontWeight: '700' }}>Agent Users</Typography>
                        </div>
                        {viewMode !== 'map' && (
                            <div style={{ display: 'flex', gap: '15px' }}>
                                {LoginUserID === 1 && SyncVisible && (
                                    <div style={{ marginTop: '15px', position: 'relative' }} onClick={OpenModalCronJob}>
                                        <div
                                            style={{ cursor: 'pointer' }}
                                            onMouseEnter={() => setShowTooltip(true)}
                                            onMouseLeave={() => setShowTooltip(false)}
                                        >
                                            <SyncIcon />
                                        </div>
                                        {showTooltip && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '100%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '5px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                Sync the users
                                            </div>
                                        )}
                                    </div>
                                )}
                                <>
                                    {buttonVisible && (
                                        <div style={{ marginTop: '10px', position: 'relative' }} onClick={handleEmailSend}>
                                            <Button
                                                style={{ cursor: 'pointer' }}
                                                onMouseEnter={() => setEmailShowTooltip(true)}
                                                onMouseLeave={() => setEmailShowTooltip(false)}
                                            >
                                                <ForwardToInboxIcon />
                                                {emailShowTooltip && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '100%',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                            color: '#fff',
                                                            padding: '5px 10px',
                                                            borderRadius: '5px',
                                                            fontSize: '11px',
                                                            whiteSpace: 'nowrap',
                                                            marginBottom: '12px',
                                                        }}
                                                    >
                                                        Send login Credential
                                                    </div>
                                                )}
                                            </Button>
                                        </div>
                                    )}
                                </>

                                {/* <ISAAddAgentModal getAgents={getAgents} getCountData={getCountData} getPefferedLocation={getPefferedLocation} /> */}
                            </div>
                        )}
                    </div>

                    <div style={{ width: 'auto' }}>
                        <Box style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                            <Button onClick={() => setViewMode('list')} variant={viewMode === 'list' ? 'contained' : 'outlined'}>
                                List View
                            </Button>
                            <Button onClick={() => setViewMode('map')} variant={viewMode === 'map' ? 'contained' : 'outlined'}>
                                Map View
                            </Button>
                        </Box>
                        <ThemeProvider theme={theme}>
                            <GlobalStyles
                                styles={{
                                    '::-webkit-scrollbar': {
                                        width: '14px', // Set the desired width for the scrollbar
                                    },
                                    '::-webkit-scrollbar-thumb': {
                                        backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                        borderRadius: '10px', // Set the border radius for a rounded effect
                                    },
                                }}
                            />
                            {viewMode === 'list' ? (
                                <Box className={classes.GetAllAgentsTableStyle}>
                                    <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                        <div className={classes.LeadTable}>
                                            <Table column={column} data={GetAllAgents} isLoading={isLoading} />
                                        </div>
                                    </Card>

                                    <Pagination
                                        count={totalPages}
                                        color="primary"
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        style={{
                                            marginTop: '-40px',
                                            zIndex: 1000,
                                            position: 'relative',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                        }}
                                    />
                                </Box>
                            ) : isLoaded ? (
                                <Box style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                    <GoogleMap
                                        options={{
                                            disableDefaultUI: false,
                                            clickableIcons: true,
                                            scrollwheel: true,
                                            mapTypeControl: false,
                                            fullscreenControl: false,
                                            streetViewControl: false,
                                            minZoom: 5,
                                        }}
                                        mapContainerStyle={containerStyle}
                                        center={mapCenter}
                                        onLoad={(map) => {
                                            mapRef.current = map;
                                        }}
                                        zoom={zoom}
                                    >
                                        {getAllAgentsForMap?.map((agent) => {
                                            // Check if lat and lng are valid and exist
                                            if (agent?.latitude && agent?.longitude) {
                                                // Concatenate the profile image with the base URL
                                                const profileImageUrl = agent?.profile_image
                                                    ? `https://iconnctapp.com/${agent?.profile_image}`
                                                    : '/public/assets/BlackAgent.png'; // Default avatar path

                                                return (
                                                    <>
                                                        <style>
                                                            {`
                                                            /* Custom styles for InfoWindow close button */
                                                            .gm-ui-hover-effect {
                                                                width: 45px !important;
                                                                height: 24px !important;
                                                            }
                                                            .gm-ui-hover-effect > img {
                                                                width: 100%;
                                                                height: 100%;
                                                                
                                                            }
                                                            `}
                                                        </style>
                                                        <OverlayView
                                                            key={agent?.id}
                                                            position={{ lat: parseFloat(agent?.latitude), lng: parseFloat(agent?.longitude) }}
                                                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                                        >
                                                            <div
                                                                style={{
                                                                    position: 'relative',
                                                                    display: 'inline-block',
                                                                    textAlign: 'center',
                                                                }}
                                                            >
                                                                {/* Custom marker with rounded image */}
                                                                <div
                                                                    style={{
                                                                        borderRadius: '50%',
                                                                        overflow: 'hidden',
                                                                        border: '2px solid white',
                                                                        cursor: 'pointer',
                                                                        backgroundColor: '#fff',
                                                                        width:
                                                                            agent?.subscription_type === 'founder'
                                                                                ? 40
                                                                                : agent?.subscription_type === 'premier'
                                                                                  ? 60
                                                                                  : agent?.subscription_type === 'elite'
                                                                                    ? 80
                                                                                    : 30,
                                                                        height:
                                                                            agent?.subscription_type === 'founder'
                                                                                ? 40
                                                                                : agent?.subscription_type === 'premier'
                                                                                  ? 60
                                                                                  : agent?.subscription_type === 'elite'
                                                                                    ? 80
                                                                                    : 30,
                                                                    }}
                                                                    title={`${agent?.name} ${agent?.last_name}`} // Tooltip on hover
                                                                >
                                                                    <Avatar
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '50%', // Rounds the image
                                                                        }}
                                                                        onClick={() => handleMarkerClick(agent)}
                                                                        src={profileImageUrl}
                                                                        sx={{ width: 60, height: 60, marginRight: '16px' }}
                                                                    />
                                                                </div>
                                                                {/* <div
                                                                    style={{
                                                                        borderRadius: '50%',
                                                                        width: '60px',
                                                                        height: '60px',
                                                                        overflow: 'hidden',
                                                                        border: '2px solid white',
                                                                        cursor: 'pointer',
                                                                        backgroundColor: '#fff',
                                                                    }}
                                                                    title={`${agent?.name} ${agent?.last_name}`} // Tooltip on hover
                                                                >
                                                                    <Avatar
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '50%', // Rounds the image
                                                                        }}
                                                                        onClick={() => handleMarkerClick(agent)}
                                                                        src={profileImageUrl}
                                                                        sx={{ width: 60, height: 60, marginRight: '16px' }}
                                                                    />
                                                                </div> */}

                                                                <div>
                                                                    {selectedAgent?.id === agent?.id && (
                                                                        <InfoWindow
                                                                            position={{
                                                                                lat: parseFloat(agent?.latitude),
                                                                                lng: parseFloat(agent?.longitude),
                                                                            }}
                                                                            onCloseClick={() => setSelectedAgent(null)}
                                                                            options={{
                                                                                pixelOffset: new window.google.maps.Size(28, -3), // Adjust this value
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                    }}
                                                                                >
                                                                                    <Avatar
                                                                                        src={
                                                                                            selectedAgent?.profile_image
                                                                                                ? `https://iconnctapp.com/${selectedAgent?.profile_image}`
                                                                                                : '/public/assets/BlackAgent.png'
                                                                                        }
                                                                                        alt={selectedAgent?.name}
                                                                                        sx={{ width: 60, height: 60, marginRight: '16px' }}
                                                                                    />
                                                                                    <Box>
                                                                                        <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                                                            {selectedAgent?.name} {selectedAgent?.last_name}
                                                                                        </Typography>
                                                                                        <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                                            📧: {selectedAgent?.email}
                                                                                        </Typography>
                                                                                        <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                                            Score: 🎯 {selectedAgent?.score}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                {/* Profile Button */}
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    color="success"
                                                                                    size="small"
                                                                                    onClick={handleProfileClick}
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        bottom: '10px',
                                                                                        right: '10px',
                                                                                        fontSize: '8px',
                                                                                    }}
                                                                                >
                                                                                    Profile
                                                                                </Button>
                                                                            </div>
                                                                        </InfoWindow>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </OverlayView>
                                                    </>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </GoogleMap>
                                </Box>
                            ) : (
                                <></>
                            )}
                        </ThemeProvider>
                    </div>
                    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        padding: '10px',
                                        gap: '10px',
                                    }}
                                >
                                    <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                        <Box>
                                            <DeleteIcon style={{ fontSize: '34px' }} />
                                        </Box>
                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                            <div>
                                                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                                    Are you sure you want to delete this user?
                                                </span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: '16px', color: '#252F46' }}>
                                                    This action will delete this user permanently, and you can not undo this.
                                                </span>
                                            </div>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                    <Button
                                        onClick={handleClose}
                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: 'white',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: '#252F46',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: '#5379BD',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: 'white',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </Box>
                            </div>
                        </Box>
                    </Modal>
                </div>
            </ScrollAnimation>

            <React.Fragment>
                <BootstrapDialog aria-labelledby="customized-dialog-title" open={ConfirmationOpen}>
                    <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold' }} id="customized-dialog-title">
                        Confirmation
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseModel}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <Typography gutterBottom>Are you sure you want to sync users with Lofty?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus disabled={isLoadingEmail} onClick={HandleRunCronJob}>
                            {isLoadingEmail ? 'Loading' : 'Yes'}
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </>
    );
};

export default Agents;
